export default __webpack_public_path__ + "static/media/arrowRightWhite.a162b706.svg";